module.exports = __webpack_public_path__ + "static/img/04rankbg.e3da1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/share/07sportRank/04rankbg.png
// module id = 0eGr
// module chunks = 0